(function () {
  const FALLBACK_COLORS = {
    black: '#1f2329',
    blue: '#3c6ca8',
    brown: '#8a6247',
    burgandy: '#70303a',
    burgundy: '#70303a',
    orange: '#c96e28',
    camel: '#b88d5d',
    green: '#4b7850',
    gold: '#b79a4a',
    graphite: '#666a73',
    gray: '#9a9ea6',
    grey: '#9a9ea6',
    red: '#a8403a',
    white: '#ece6dc',
    tan: '#b79769',
    taupe: '#9c8775',
    saddle: '#8a6445',
    mocha: '#7d5d4c'
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/\([^)]*\)/g, ' ')
      .replace(/[-_/]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function handleize(value) {
    return normalize(value)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function guessColor(value) {
    const normalized = normalize(value);
    const match = Object.keys(FALLBACK_COLORS).find(function (name) {
      return normalized.indexOf(name) !== -1;
    });

    return match ? FALLBACK_COLORS[match] : '#d7d2ca';
  }

  function getProductData(root) {
    const jsonNode = root.querySelector('[data-color-palette-product-json]');
    if (!jsonNode) return null;

    try {
      return JSON.parse(jsonNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function findProductForm(root) {
    const section = root.closest('product-info, product-form, section, .shopify-section');
    return (
      (section && section.querySelector('form[action*="/cart/add"]')) ||
      root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function findSearchScope(root) {
    return (
      root.closest('product-info') ||
      root.closest('product-form') ||
      root.closest('.shopify-section') ||
      root.closest('section') ||
      document
    );
  }

  function findOptionSelect(root, optionName, optionPosition) {
    const scope = findSearchScope(root);
    const selects = scope.querySelectorAll('select[name^="options["], variant-selects select, .product-form__input select');
    for (let i = 0; i < selects.length; i += 1) {
      const select = selects[i];
      if (
        select.name === 'options[' + optionName + ']' ||
        Number(select.getAttribute('data-option-position')) === optionPosition
      ) {
        return select;
      }
    }

    if (selects[optionPosition - 1]) return selects[optionPosition - 1];

    return null;
  }

  function findCurrentValue(root, optionName, optionPosition) {
    const select = findOptionSelect(root, optionName, optionPosition);
    if (select && select.value) return select.value;

    const radios = document.querySelectorAll('input[type="radio"][name^="options["]');
    for (let i = 0; i < radios.length; i += 1) {
      const radio = radios[i];
      if (radio.name === 'options[' + optionName + ']' && radio.checked) {
        return radio.value;
      }
    }

    const productData = getProductData(root);
    if (productData && productData.selected_or_first_available_variant) {
      return productData.selected_or_first_available_variant.options[optionPosition - 1];
    }

    return '';
  }

  function setDropdownValue(select, value) {
    if (!select || !value || select.value === value) return;
    select.value = value;
    const matchingOption = Array.prototype.find.call(select.options || [], function (option) {
      return option.value === value;
    });
    if (matchingOption) {
      select.selectedIndex = matchingOption.index;
    }
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setRadioValue(optionName, value) {
    const radios = document.querySelectorAll('input[type="radio"][name^="options["]');
    radios.forEach(function (radio) {
      if (radio.name === 'options[' + optionName + ']' && radio.value === value && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.click();
      }
    });
  }

  function buildSwatchLookup(items) {
    const lookup = {};
    items.forEach(function (item) {
      if (!item || !item.value) return;
      lookup[normalize(item.value)] = item;
      lookup[handleize(item.value)] = item;
    });
    return lookup;
  }

  function updateSelection(root, state, value) {
    const normalized = normalize(value);
    const selected = state.lookup[normalized] || state.lookup[handleize(value)];
    const activeModal = root._colorPaletteModal || root.querySelector('[data-color-palette-modal]');
    const swatches = activeModal ? activeModal.querySelectorAll('[data-color-palette-swatch]') : [];

    swatches.forEach(function (button) {
      const isSelected = normalize(button.dataset.value) === normalized;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
    });

    const labels = document.querySelectorAll(
      '[data-color-palette-picker] [data-color-palette-selected-label], ' +
      '[data-color-palette-picker] [data-color-palette-summary-label], ' +
      '.color-palette-picker__modal [data-color-palette-selected-label], ' +
      '.color-palette-picker__modal [data-color-palette-summary-label]'
    );
    labels.forEach(function (node) {
      node.textContent = value || state.defaultLabel;
    });

    const chips = document.querySelectorAll(
      '[data-color-palette-picker] [data-color-palette-selected-chip], ' +
      '.color-palette-picker__modal [data-color-palette-selected-chip]'
    );
    const hexLabels = root.querySelectorAll('[data-color-palette-selected-hex]');
    const launcherPrices = root.querySelectorAll('[data-color-palette-launcher-price]');
    const color = selected ? selected.fallback_color : guessColor(value);
    root.style.setProperty('--selected-color', color);
    if (activeModal) {
      activeModal.style.setProperty('--selected-color', color);
    }
    chips.forEach(function (chip) {
      chip.style.setProperty('--chip-color', color);
    });
    hexLabels.forEach(function (node) {
      node.textContent = color.toUpperCase();
    });
    launcherPrices.forEach(function (node) {
      const delta = selected && typeof selected.price_delta === 'number' ? selected.price_delta : 0;
      const isBlackSelection = normalized.indexOf('black') !== -1;
      if (delta > 0 && !isBlackSelection) {
        node.textContent = '+' + formatMoney(delta) + ' paint upgrade';
        node.hidden = false;
      } else {
        node.textContent = '';
        node.hidden = true;
      }
    });

    const launcherImages = root.querySelectorAll('[data-color-palette-launcher-image]');
    launcherImages.forEach(function (image) {
      if (selected && selected.asset_url) {
        if (image.getAttribute('src') !== selected.asset_url) {
          image.setAttribute('src', selected.asset_url);
        }
        image.style.display = '';
        image.setAttribute('alt', value || state.defaultLabel);
      } else {
        image.style.display = 'none';
      }
    });
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    if (Number.isInteger(amount)) return '$' + amount.toFixed(0);
    const oneDecimal = amount.toFixed(1);
    if (Number(oneDecimal) === amount) return '$' + oneDecimal;
    return '$' + amount.toFixed(2);
  }

  function openModal(root) {
    const modal = root._colorPaletteModal || root.querySelector('[data-color-palette-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('color-palette-picker-open');
  }

  function closeModal(root) {
    const modal = root._colorPaletteModal || root.querySelector('[data-color-palette-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('color-palette-picker-open');
  }

  function bindPicker(root) {
    const optionName = root.dataset.optionName || 'Color';
    const optionPosition = Number(root.dataset.optionPosition || 1);
    const swatchScript = root.querySelector('[data-color-palette-swatch-json]');
    if (!swatchScript) return;

    const swatchData = JSON.parse(swatchScript.textContent || '[]');
    const modal = root.querySelector('[data-color-palette-modal]');
    const state = {
      lookup: buildSwatchLookup(swatchData),
      defaultLabel: root.dataset.defaultLabel || 'Choose color'
    };

    if (modal && !modal.dataset.portalized) {
      modal.dataset.portalized = 'true';
      root._colorPaletteModal = modal;
      document.body.appendChild(modal);
    }

    updateSelection(root, state, findCurrentValue(root, optionName, optionPosition));

    const button = root.querySelector('[data-color-palette-open]');
    const activeModal = root._colorPaletteModal || modal;
    const closeButtons = activeModal ? activeModal.querySelectorAll('[data-color-palette-close]') : [];
    const swatches = activeModal ? activeModal.querySelectorAll('[data-color-palette-swatch]') : [];

    if (button) {
      button.addEventListener('click', function () {
        openModal(root);
      });
    }

    closeButtons.forEach(function (node) {
      node.addEventListener('click', function () {
        closeModal(root);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal(root);
    });

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        const value = swatch.dataset.value;
        const dropdown = findOptionSelect(root, optionName, optionPosition);
        setDropdownValue(dropdown, value);
        setRadioValue(optionName, value);
        updateSelection(root, state, value);
        closeModal(root);
      });
    });

    if (activeModal) {
      activeModal.querySelectorAll('img[data-color-palette-image]').forEach(function (image) {
        image.addEventListener('error', function () {
          image.style.display = 'none';
        });
      });
    }

    root.querySelectorAll('img[data-color-palette-launcher-image]').forEach(function (image) {
      image.addEventListener('error', function () {
        image.style.display = 'none';
      });
      image.addEventListener('load', function () {
        image.style.display = '';
      });
    });

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target || !target.matches) return;

      if (
        target.matches('select[name^="options["], variant-selects select, .product-form__input select') &&
        (
          target.name === 'options[' + optionName + ']' ||
          Number(target.getAttribute('data-option-position')) === optionPosition
        )
      ) {
        updateSelection(root, state, target.value);
      }

      if (target.matches('input[type="radio"][name^="options["]') && target.name === 'options[' + optionName + ']') {
        updateSelection(root, state, target.value);
      }

      if (target.matches('input[name="id"], select[name="id"]')) {
        const productData = getProductData(root);
        if (!productData || !productData.variants) return;

        const selectedVariant = productData.variants.find(function (variant) {
          return String(variant.id) === String(target.value);
        });

        if (selectedVariant) {
          updateSelection(root, state, selectedVariant.options[optionPosition - 1]);
        }
      }
    });

    document.addEventListener('input', function (event) {
      const target = event.target;
      if (!target || !target.matches) return;

      if (
        target.matches('select[name^="options["], variant-selects select, .product-form__input select') &&
        (
          target.name === 'options[' + optionName + ']' ||
          Number(target.getAttribute('data-option-position')) === optionPosition
        )
      ) {
        updateSelection(root, state, target.value);
      }
    });
  }

  document.querySelectorAll('[data-color-palette-picker]').forEach(bindPicker);
})();
